import { Interval as ApiInterval } from '@vendasta/billing';

export enum Interval {
  INVALID = 'Invalid',
  DAY = 'Daily',
  WEEK = 'Weekly',
  MONTH = 'Monthly',
  YEAR = 'Yearly',
}

export function convertFromApiInterval(s: ApiInterval): Interval {
  switch (s) {
    case ApiInterval.INTERVAL_INVALID:
      return Interval.INVALID;
    case ApiInterval.INTERVAL_DAY:
      return Interval.DAY;
    case ApiInterval.INTERVAL_WEEK:
      return Interval.WEEK;
    case ApiInterval.INTERVAL_MONTH:
      return Interval.MONTH;
    case ApiInterval.INTERVAL_YEAR:
      return Interval.YEAR;
    default:
      return Interval.INVALID;
  }
}

export function convertToApiInterval(s: Interval): ApiInterval {
  switch (s) {
    case Interval.INVALID:
      return ApiInterval.INTERVAL_INVALID;
    case Interval.DAY:
      return ApiInterval.INTERVAL_DAY;
    case Interval.WEEK:
      return ApiInterval.INTERVAL_WEEK;
    case Interval.MONTH:
      return ApiInterval.INTERVAL_MONTH;
    case Interval.YEAR:
      return ApiInterval.INTERVAL_YEAR;
    default:
      return ApiInterval.INTERVAL_INVALID;
  }
}
